import { userActions, msgActions } from "../redux/actions";

const authError = [
  "InvalidUsernameOrPassword",
  "InvalidTokenPassed",
  "NoTokenPassed",
  "TokenCacheNotAvailable"
];

export function handleErrors(error, dispatch, msgHeader) {
  if (typeof error === "object" && error !== null) {
    error.message && dispatch(msgActions.error("Server error response", error.message));
  } else if (authError.includes(error)) {
    dispatch(userActions.logout(window.loggedInBrowserHistory));
  } else {
    dispatch(msgActions.error(msgHeader || "Server error response", error));
  }
}
